module.exports = __webpack_public_path__ + "img/ibmp_nasal_passo_3.a6dc55eb.gif";